var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{staticClass:"section-box"},[_c('div',{staticClass:"section-box-header"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"section-box-body"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }